import { render, staticRenderFns } from "./questionUserDetail.vue?vue&type=template&id=59693642"
import script from "./questionUserDetail.vue?vue&type=script&lang=js"
export * from "./questionUserDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports